const urls = {
	projectPlannerUrl: "site-selector",
	analyticsUrl: "analytics",
	suppliersUrl: "suppliers"
};

export default urls;
